<template>
  <DsPageContent>
    <DsSectionImage
      v-if="content.image"
      :image="content.image"
      class="ds-margin-bottom-48 ds-md-margin-bottom-0"
      :screen="screen"
    />
    <DsSection
      v-if="downloadPdfButton"
      :with-space="false"
    >
      <div class="ds-display-flex ds-justify-content-flex-end ds-width-full">
        <DsLink
          class="ds-margin-top-12"
          v-bind="downloadPdfButton"
        />
      </div>
    </DsSection>
    <InvestorRelationsShareholderLetterContentBlock
      v-if="content && content.letter"
      :title="content.letter.title"
      :text="content.letter.text"
      :footnote="content.letter.footnote"
    />

    <DsCallToAction
      v-if="financialStatements"
      v-bind="financialStatements"
      alignment="left"
      with-title-size-large
    />
    <section v-if="content.notice">
      <div class="ds-container ds-padding-y-48 ds-md-padding-y-96">
        <div class="ds-grid ds-justify-content-center">
          <div class="ds-grid__col ds-grid__col--12 ds-md-grid__col--8">
            <RichText :data="content.notice" />
          </div>
        </div>
      </div>
    </section>
  </DsPageContent>
</template>
<script setup>
import { DsPageContent, DsSectionImage, DsCallToAction, DsLink, DsSection } from 'awds'
const { labels } = useInvestorsGlobalData()
const { screen } = useScreen()

definePageMeta({ layout: 'investors-layout' })

const props = defineProps({ pageContent: { type: Object, default: () => null } })

const content = computed(() => {
  return props.pageContent || {}
})

const financialStatements = computed(() => {
  if (!content.value.financialStatementsPdf) {
    return null
  }
  return {
    title: content.value.title,
    subtitle: `${content.value.period} ${labels.value.companyLegalName}`,
    primaryLink: { ...downloadPdfButton.value }
  }
})

const downloadPdfButton = computed(() => {
  if (!content.value.financialStatementsPdf) {
    return null
  }

  return {
    ...content.value.financialStatementsPdf,
    title: labels.value.downloadPdf,
    type: 'button',
    text: labels.value.downloadPdf,
    content: labels.value.downloadPdf,
    url: content.value.financialStatementsPdf.link.url,
    iconRight: { category: 'arrows', name: 'download' }
  }
})
</script>
